import { OT_CURRENT_PAYMENT_INSTRUMENT } from '../helpers/apis';
import apiClient from '../middleware/apiClient';
import { COTTON_OT_CURRENT_PAYMENT_INSTRUMENT } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_CURRENT_XM_INSTRUMENT = 'GET_CURRENT_XM_INSTRUMENT';
export const GET_CURRENT_XM_INSTRUMENT_SUCCESS = 'GET_CURRENT_XM_INSTRUMENT_SUCCESS';
export const GET_CURRENT_XM_INSTRUMENT_FAILURE = 'GET_CURRENT_XM_INSTRUMENT_FAILURE';
export const POST_CURRENT_XM_INSTRUMENT = 'POST_CURRENT_XM_INSTRUMENT';
export const POST_CURRENT_XM_INSTRUMENT_SUCCESS = 'POST_CURRENT_XM_INSTRUMENT_SUCCESS';
export const POST_CURRENT_XM_INSTRUMENT_FAILURE = 'POST_CURRENT_XM_INSTRUMENT_FAILURE';

// GET
function dispatchGetCurrentXMInstrument(isCottonSession = false) {
  const endpoint = isCottonSession
    ? COTTON_OT_CURRENT_PAYMENT_INSTRUMENT
    : OT_CURRENT_PAYMENT_INSTRUMENT;
  return {
    type: GET_CURRENT_XM_INSTRUMENT,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetCurrentXMInstrumentSuccess(instrument) {
  return {
    type: GET_CURRENT_XM_INSTRUMENT_SUCCESS,
    payload: instrument,
  };
}

function dispatchGetCurrentXMInstrumentFailure(error) {
  return {
    type: GET_CURRENT_XM_INSTRUMENT_FAILURE,
    payload: error,
  };
}

// Get Current XM Payment Autopay Instrument
export const getCurrentXMInstrument = () => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchGetCurrentXMInstrument(isCottonSession)).payload;
    dispatch(dispatchGetCurrentXMInstrumentSuccess(response));
    return response;
  } catch (error) {
    dispatch(dispatchGetCurrentXMInstrumentFailure(error));
    throw error;
  }
};

// POST
function dispatchPostCurrentXMInstrument(data, isCottonSession = false) {
  const endpoint = isCottonSession
    ? COTTON_OT_CURRENT_PAYMENT_INSTRUMENT
    : OT_CURRENT_PAYMENT_INSTRUMENT;
  return {
    type: POST_CURRENT_XM_INSTRUMENT,
    payload: apiClient.fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    }),
  };
}

function dispatchPostCurrentXMInstrumentSuccess(result) {
  return {
    type: POST_CURRENT_XM_INSTRUMENT_SUCCESS,
    payload: result,
  };
}

function dispatchPostCurrentXMInstrumentFailure(error) {
  return {
    type: POST_CURRENT_XM_INSTRUMENT_FAILURE,
    payload: error,
  };
}

// POST Current XM Payment Autopay Instrument
export const postCurrentXMInstrument = data => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchPostCurrentXMInstrument(data, isCottonSession)).payload;
    // so Confirmation isn't bounced back to the edit page when the response echo is incomplete
    return dispatch(dispatchPostCurrentXMInstrumentSuccess({ ...data, ...response }));
  } catch (error) {
    dispatch(dispatchPostCurrentXMInstrumentFailure(error));
    throw error;
  }
};
